import React, { useEffect, useState } from "react";
import {
  CardActionArea,
  CardContent,
  CardMedia,
} from "@mui/material";
import AOS from "aos";
import "aos/dist/aos.css";
import { images } from "../../config/images";
import { aboutUsData, setting } from "../../config/services";
import "./AboutUsCulture.css";

const AboutUsculture = ({
  settingAPIDataChild,
  headerAPIDataChild,
  aboutUsAPIData,
  aboutUsLoading
}) => {
  useEffect(() => {
    AOS.init({ duration: 1200 });
  }, []);

  return (
    <>
      {/* <div className="section-padding"></div> */}

      <div className="why-choose-us-section">
        <img
          src={images.whyChooseUs}
          alt="image"
          className="why-choose-us-img"
        />
        <h1>Why Choose Us</h1>
        <div className="why-choose-us-element">
          <img
            src={images.leftSpirrel}
            alt="Left Molecule"
            className="why-choose-us-molecule"
          />
        </div>
      </div>

      <div className="common-sec">
        <div className="culture-box-wrap">
          {!aboutUsLoading  ? (
            aboutUsAPIData[1]?.why_choose_us?.map((item, index) => (
              <div key={index} className="culture-data-wrap">
                <div className="culture-data">
                  <CardActionArea>
                    <CardMedia
                      component="img"
                      image={item ? item?.image : ""}
                      alt="image"
                      className="culture-img"
                    />
                    <CardContent className="card-culture">
                      <h3 className="mt-2 culture-title">
                        {item ? item?.title : ""}
                      </h3>
                      <p className="mt-3 culture-description">
                        {item ? item?.description : ""}
                      </p>
                    </CardContent>
                  </CardActionArea>
                </div>
              </div>
            ))
          ) : (
            // If data is not available, show shimmer effect
            <>
              <div className="culture-data-wrap">
                <div className="culture-data">
                  <CardActionArea>
                    <CardMedia className="culture-img-1" />
                    <CardContent className="card-culture">
                      <div className="culture-title-shimmer" />
                      <p className="mt-3 culture-description-shimmer" />
                      <p className="mt-3 culture-description-shimmer" />
                      <p className="mt-3 culture-description-shimmer" />
                      <p className="mt-3 culture-description-shimmer" />
                    </CardContent>
                  </CardActionArea>
                </div>
              </div>
              <div className="culture-data-wrap">
                <div className="culture-data">
                  <CardActionArea>
                    <CardMedia className="culture-img-1" />
                    <CardContent className="card-culture">
                      <div className="culture-title-shimmer" />
                      <p className="mt-3 culture-description-shimmer" />
                      <p className="mt-3 culture-description-shimmer" />
                      <p className="mt-3 culture-description-shimmer" />
                      <p className="mt-3 culture-description-shimmer" />
                    </CardContent>
                  </CardActionArea>
                </div>
              </div>
              <div className="culture-data-wrap">
                <div className="culture-data">
                  <CardActionArea>
                    <CardMedia className="culture-img-1" />
                    <CardContent className="card-culture">
                      <div className="culture-title-shimmer" />
                      <p className="mt-3 culture-description-shimmer" />
                      <p className="mt-3 culture-description-shimmer" />
                      <p className="mt-3 culture-description-shimmer" />
                      <p className="mt-3 culture-description-shimmer" />
                    </CardContent>
                  </CardActionArea>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default AboutUsculture;
